// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4983ec9f","179":"0a5f62fa","213":"0c8f1caa","219":"1d8f2ce0","367":"9e4f5dde","445":"e8aa8fc0","453":"d1fa110c","547":"529d30b4","564":"43b544e4","624":"bc99d268","732":"74d40df9","824":"6c721a7a","955":"9fc1950d"}[chunkId] + ".chunk.js";
};